module.exports = __webpack_public_path__ + "img/whatsapp.26771836.svg";